import Dialog from 'common/dashboard/dashboard/dialog'
import Rails from "@rails/ujs";

Rails.confirm = function(msg, element) {
  if(!element.dataset.ujsConfirmed) {
    Dialog.confirm({message: msg}).then((r)=> {
      if(r) {
        element.dataset.ujsConfirmed = true
        if(element.nodeName == 'FORM')
          element.submit()
        else
          element.click()
        element.dataset.ujsConfirmed = false
      }
    })
  }

  return !!element.dataset.ujsConfirmed;
}


Rails.start();
